var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("select2", {
    staticClass: "form-control",
    attrs: {
      value: _vm.value,
      "plugin-options": _vm.courseGroupsSelect2Options,
      "dropdown-parent-selector": _vm.dropdownParentSelector,
      options: _vm.courseGroupsOptions,
      "additional-fields": ["isHidden", "name"],
      disabled: _vm.disabled
    },
    on: {
      input: function($event) {
        return _vm.$emit("input", $event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }